import React from 'react';
import { withResolver } from 'components/common';
import { FormGroup } from 'components/common/Forms';
import { compose, withState } from 'recompose';
import { Control } from 'react-redux-form';
import { Card, CardBody } from 'reactstrap';
import { Creatable } from 'react-select';

export const InstallerIssuers = ({ issuers, is_all_issuers, readOnly}) =>(
  <FormGroup>
    <Card>
      <CardBody>
        <FormGroup label="Issuers" >
          <Control.select
            model=".issuers"
            placeholder="None Set"
            component={Creatable}
            options={issuers}
            multi
            labelKey="description"
            valueKey="issuer_id"
            disabled={readOnly || is_all_issuers}
          />
        </FormGroup>
        <FormGroup label="All Issuers" check disabled={readOnly}>
          <Control.checkbox 
            model=".is_all_issuers"
          />
        </FormGroup>
      </CardBody>
    </Card>
  </FormGroup>
);

const enhance = compose(
  withState('issuers', 'setIssuers', null),
  withResolver({
      issuers: () => client => client.get('issuers'),
  }, {
    onResolved: ({ setIssuers }) => ({ issuers }) => {
      setIssuers(issuers);
    }
  })
);

export default enhance(InstallerIssuers);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerIssuers.jsx